<template>
    <div class="main">
        <!-- channel banner -->
        <div class="cbanner">
            <img src="../../assets/images/banner_list.jpg" />
            <div class="btext">
                <h3>借贷大厅</h3>
                <p>专业的互联网借贷信息中介平台</p>
            </div>
        </div><!-- channel banner END-->
        <div class="main_inner">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <span class="btitle">当前位置：</span>
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>借贷大厅</el-breadcrumb-item>
                <el-breadcrumb-item>债权转让</el-breadcrumb-item>
            </el-breadcrumb>
            <!-- business list -->
            <el-row class="business_list">
                <el-col :span="18" class="b_list">
                    <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" background-color="#f6f6f6" @select="handleSelect">
                        <el-menu-item index="1">更新时间</el-menu-item>
                        <el-menu-item index="2">转让金额</el-menu-item>
                        <el-menu-item index="3">最新项目信息</el-menu-item>
                        <div class="bl_status">共有 <span class="color_default">{{total}}</span> 条转让信息</div>
                    </el-menu>
                    <ul class="blist">
                        <li v-for="project in projectArray">
                            <el-row class="title_bl">
                                <el-col :span="18">{{project.creditorName}}：{{project.projectCode}}</el-col>
                                <el-col :span="6">
                                  <el-button type="default" v-if="project.realTimeStatus==1" @click="goProjectDetail(project.id)">已完成</el-button>
                                  <el-button type="default" v-else-if="project.deadline > 0" @click="goProjectDetail(project.id)">项目详情</el-button>
                                  <el-button type="default" v-else @click="goProjectDetail(project.id)">已过期</el-button>
                                </el-col>
                            </el-row>
                            <el-row class="txt_bl">
                                <el-col :span="6">
                                    <span class="desc_tbl">还款方式：{{repaymentMethodFormatter(project.repaymentMethod)}}</span><br/>
                                    <span class="desc_tbl">转让方：{{project.transferor}}</span>
                                </el-col>
                                <el-col :span="4"><span class="data_tbl light_tbl">{{project.yieldRate}}<sub>%</sub></span><br><span class="title_tbl">预期收益率</span></el-col>
                                <el-col :span="4"><span class="data_tbl">{{project.amount}}<sub>元</sub></span><br><span class="title_tbl">转让金额</span></el-col>
                                <el-col :span="4"><span class="data_tbl">{{deadlineFormatter(project.deadline)}}<sub>天</sub></span><br><span class="title_tbl">剩余期限</span></el-col>
                                <el-col :span="6"><span class="data_tbl">{{project.guaranteeMethodNames}}</span><br><span class="title_tbl">保证方式</span></el-col>
                            </el-row>
                        </li>
                    </ul>
                    <el-pagination
                            background
                            @current-change="handleCurrentChange"
                            :page-size="pageSize"
                            layout="prev, pager, next"
                            :total="total">
                    </el-pagination>

                </el-col>
                <el-col :span="6" class="b_side">

                    <!-- calculator END -->
                    <div class="calculator">
                        <h3 class="title_side">收益计算器</h3>
                        <el-row :gutter="6">
                            <el-col :span="8">计息方式：</el-col>
                            <el-col :span="16">
                                <label>按月付息，到期还本</label>
                            </el-col>
                        </el-row>
                        <el-row :gutter="6">
                            <el-col :span="8">出借金额：</el-col>
                            <el-col :span="14">
                                <el-input v-model="loanAmount" placeholder="输入出借金额"></el-input>
                                <span id="loanAmountError" style="color: red"></span>
                            </el-col>
                            <el-col :span="2">
                                <span>元</span>
                            </el-col>
                        </el-row>
                        <el-row :gutter="6">
                            <el-col :span="8">借款利率：</el-col>
                            <el-col :span="14">
                                <el-input v-model="bRate" placeholder="输入借款利率"></el-input>
                                <span id="bRateError" style="color: red"></span>
                            </el-col>
                            <el-col :span="2">
                                <span>%</span>
                            </el-col>
                        </el-row>
                        <el-row :gutter="6">
                            <el-col :span="8">出借期限：</el-col>
                            <el-col :span="10">
                                <el-input v-model="loanPeriod" placeholder="输入出借期限"></el-input>
                                <span id="loanPeriodError" style="color: red"></span>
                            </el-col>
                            <el-col :span="6">
                                <el-select v-model="dataOrMouth" clearable placeholder="选择">
                                  <el-option
                                    v-for="item in dataOrMouthArray"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                  </el-option>
                                </el-select>
                                <span id="loanDataOrMouthError" style="color: red"></span>
                            </el-col>
                        </el-row>
                        <el-row :gutter="6" id="myresult" style="display: none">
                            <el-col :span="10">利息收益：</el-col>
                            <el-col :span="14">
                                <label id="interestIncome"></label>
                            </el-col>
                        </el-row>
                        <el-row class="btns_calcutator">
                            <el-col :span="12">
                                <el-button type="default" @click="clearMe">清空</el-button>
                            </el-col>
                            <el-col :span="12">
                                <el-button type="primary" @click="calculate">计算</el-button>
                            </el-col>
                        </el-row>
                    </div>
                    <!-- calculator END -->

                    <!-- big btns -->
                    <div class="bs_big_btns">
                        <a @click="goBorrowProject"><i class="iconfont">&#xe736;</i>借入项目</a>
                        <a @click="goLoanProject"><i class="iconfont">&#xe735;</i>出借项目</a>
                        <a @click="goEcInvestment"><i class="iconfont">&#xe738;</i>股权/基金投资</a>
                        <a @click="goDownload"><i class="iconfont">&#xe60c;</i>下载资料</a>
                    </div><!-- big btns END -->

                    <!-- cases END -->
                    <div class="cases_side">
                        <h3 class="title_side">项目成交案例<a @click="goCaseList">更多</a></h3>
                        <div class="cs_list" v-if="this.hotRCArray.length>0">
                            <a v-for="hc in hotRCArray" @click="goRCDetail(hc.id)">
                                <img :src="downloadFileURL+hc.imageUrl+'/'" />
                                {{hc.title}}
                            </a>
                        </div>
                    </div>
                    <!-- cases END -->

                </el-col>
            </el-row>
            <!-- business list END-->
        </div>
        <!-- 弹出层 -->
        <el-dialog width="640px" title="提示消息" :visible.sync="dialogMsgVisible" top="36vh" center>
            <el-row>
                <el-col>
                    温馨提示：您需要注册账户并登录成功后才能查看项目详情，会员可直接点击项目详情发送信息，平台将会在24小时内安排专人主动和您取得联系。或者您可以拨打服务热线 400 029 7800 获取项目详细信息。
                </el-col>
            </el-row>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="goRegister">立即注册</el-button>
                <el-button @click="goLogin">直接登录</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
    import {reqAssignmentDebtListPage, reqValidateWebUser,reqGetCaseShowCount} from '../../api/projectManagement-api'
    import {reqGetDictionaryListByCode,reqGetDictionaryByIdList,reqGetOneByCode,downloadFileURL} from '../../api/system-api';
    import {reqGetHotRC} from '../../api/contentManagement-api'
    import {reqWebUserOne} from '../../api/webUser-api.js'

    export default {
        data(){
            return{
                activeIndex: '1',
                total:0,
                pageNum:1,
                pageSize:15,
                uName:'',
                projectArray:[],
                showStatus:0,
                 dataOrMouth:'',
                dialogMsgVisible:false,
                hotRCArray:[],
                downloadFileURL:downloadFileURL,
                loanAmount:'',
                bRate:'',
                loanPeriod:'',
                borrowMainArray:[],
              type:'',
              dataOrMouthArray:[
                {value:'0',label:'天'},
                {value:'1',label:'月'},
              ],
              orderBy:'',
              realTimeStatus:'',
            }
        },
        methods:{
            checkIntegerAndDecimal(value){
                if (!value) {
                    return -2;
                }
                var reg =/^\d+(\.\d{1,2})?$/;
                if (reg.test(value)) {
                    return 1;
                } else {
                    return -1;
                }
            },
            clearMe(){
                this.loanAmount = '';
                this.bRate = '';
                this.loanPeriod = '';
                this.dataOrMouth='';
                $('#loanAmountError').hide();
                $('#bRateError').hide();
                $('#loanPeriodError').hide();
                $('#myresult').hide();
              $('#loanDataOrMouthError').hide();
            },
            calculate(){
                var isInvalidate = false;
                var val = this.checkIntegerAndDecimal(this.loanAmount);
                if(val == -2){
                    $('#loanAmountError').html('请输入出借金额');
                    $('#loanAmountError').show();
                    isInvalidate = true;
                }else if(val == -1){
                    $('#loanAmountError').html('输入的出借金额不正确');
                    $('#loanAmountError').show();
                    isInvalidate = true;
                }else{
                    $('#loanAmountError').hide();
                    isInvalidate = false;
                }

                val = this.checkIntegerAndDecimal(this.bRate);
                if(val == -2){
                    $('#bRateError').html('请输入借款利率');
                    $('#bRateError').show();
                    isInvalidate = true;
                }else if(val == -1){
                    $('#bRateError').html('输入的借款利率不正确');
                    $('#bRateError').show();
                    isInvalidate = true;
                }else{
                    $('#bRateError').hide();
                    isInvalidate = false;
                }
                val = this.checkIntegerAndDecimal(this.loanPeriod);
                if(val == -2){
                    $('#loanPeriodError').html('请输入借出期限');
                    $('#loanPeriodError').show();
                }else if(val == -1) {
                  $('#loanPeriodError').html('输入的借出期限不正确');
                  $('#loanPeriodError').show();
                }else{
                    $('#loanPeriodError').hide();
                    isInvalidate = false;
                }
              if(!this.dataOrMouth) {
                $('#loanDataOrMouthError').html('请选择');
                $('#loanDataOrMouthError').show();
                isInvalidate = true;
              }else{
                $('#loanDataOrMouthError').hide();
                isInvalidate = false;
              }
                if(isInvalidate){
                    return false;
                }else{
                  var result='';
                  if(this.dataOrMouth=='0'){
                    result=Math.round((this.loanAmount*this.bRate/100)/365*this.loanPeriod)
                  }else if(this.dataOrMouth=='1'){
                    result = Math.round((this.loanAmount*this.bRate/100)/12*this.loanPeriod);
                  }
                    $('#loanAmountError').hide();
                    $('#bRateError').hide();
                    $('#loanPeriodError').hide();
                  $('#loanDataOrMouthError').hide();
                    $('#myresult').show();
                    $('#interestIncome').html(result);
                }
            },
            handleSelect(key, keyPath) {
                this.activeIndex = key;
                this.getProjects();
            },
            getProjects(){
                let that=this;
                reqGetOneByCode({code:'project_on_the_shelf'}).then((res) =>{
                    if(res.data.code == 1){
                        if(that.activeIndex=='1'){
                          this.orderBy='publish_time';
                        }else if(that.activeIndex=='2'){
                          this.orderBy='amount';
                        }else if(that.activeIndex=='3'){
                          this.orderBy='real_time_status';
                        }
                        let para = {
                            pageNum: that.pageNum,
                            pageSize: that.pageSize,
                            projectStatus: res.data.data.id,
                            orderBy: this.orderBy,
                        };
                        reqAssignmentDebtListPage(para).then((res) =>{
                          if(res.data.code === 1){
                            that.total = res.data.data.total;
                            that.projectArray = res.data.data.list;
                          }
                        });
                      this.realTimeStatus='';
                      this.orderBy='';
                    }
                });
            },
            getDictionarys: function() {
              var that = this;
              reqGetDictionaryListByCode({code: 'reimbursement_means'}).then((res) => {
                that.repaymentMethodArray = res.data.data;
              });
            },
            repaymentMethodFormatter: function(value){
              var res = '';
              this.repaymentMethodArray.forEach(function (obj, i) {
                if (value == obj.id) {
                  res = obj.name;
                }
              });
              return res;
            },
            deadlineFormatter: function(value){
              var res = value;
              if(value<=0)
                  res = 0;
              return res;
            },
            goProjectDetail(id){
                reqValidateWebUser({}).then((res) =>{
                    if(res.data.code == 1)
                        this.$router.push({name: 'assignmentDebtDetail', query: {id: id}});
                    else
                        this.dialogMsgVisible = true;
                });

            },
            goRegister(){
                this.$router.push({name: 'register',query: {redirect: this.$router.currentRoute.fullPath}});
            },
            goLogin(){
              this.dialogProjectVisible=false;
              this.$router.push({path:'/login',query: {redirect: this.$router.currentRoute.fullPath}})
            },
            handleCurrentChange(val) {
                this.pageNum = val;
                this.currentPage = val;
                this.getProjects();
                this.getBackTop();
            },
            goBorrowProject(){
                this.$router.push({name: 'borrowProject'});
            },
            goLoanProject(){
                this.$router.push({name: 'loanProject'});
            },
            goEcInvestment(){
                this.$router.push({name: 'ecInvestmentIntroduction'});
            },
            goDownload(){
                this.$router.push({name: 'dataDownload'});
            },
            goCaseList(){
                this.$router.push({name: 'caseShow'});
            },
            getGetHotRC(){
                reqGetOneByCode({code:'counseling_case_shows'}).then((res) =>{
                    if(res.data.code == 1){
                        let para = {
                            publishType: res.data.data.id,
                            orderField: 'publish_time',
                            orderRule: 'desc',
                            startIndex: 0,
                            rowCounts: 3
                        };
                        reqGetHotRC(para).then((res) =>{
                            this.hotRCArray = res.data.data;
                        });
                    }
                });
            },
          goRCDetail(id){
            reqGetCaseShowCount().then(res=>{
              this.total=0;
              this.total=res.data.data;
              this.$router.push({name: 'caseShowDetail', query: {id: id,total:this.total}});
            });
          },
        },
        mounted(){
            this.$store.dispatch('showHF');
            this.getDictionarys();
            this.getProjects();
            this.getGetHotRC();
        },
    }
</script>

<style slot-scope="scope">
    .el-dialog__wrapper .el-dialog .el-dialog__body { line-height: 2; }
</style>



// WEBPACK FOOTER //
// src/components/projectManagement/AssignmentDebt.vue